import { Eye } from "lucide-react";
import { KpiTile } from "./KpiTile";
import type { ContentEngagementSummary } from "@colab/shared";

export function ContentEngagementCard({
  summary,
}: {
  summary: ContentEngagementSummary;
}) {
  const { topAssets, totals } = summary;
  const max = Math.max(...topAssets.map((a) => a.views), 1);

  return (
    <section className="rounded-xl border bg-card p-5">
      <header className="mb-4">
        <h2 className="font-display text-base font-semibold tracking-tight">
          Content engagement
        </h2>
        <p className="mt-0.5 text-xs text-muted-foreground">
          Views and most-opened assets by this partner.
        </p>
      </header>

      <div className="grid grid-cols-2 gap-3">
        <KpiTile
          label="Views"
          value={totals.views.current.toLocaleString()}
          delta={totals.views}
          icon={Eye}
          className="p-3"
        />
        <KpiTile
          label="Unique assets"
          value={totals.uniqueAssets.current.toLocaleString()}
          delta={totals.uniqueAssets}
          className="p-3"
        />
      </div>

      <div className="mt-5">
        <h3 className="mb-3 text-[11px] font-medium uppercase tracking-wider text-muted-foreground">
          Top assets
        </h3>
        {topAssets.length === 0 ? (
          <p className="rounded-md border border-dashed bg-muted/30 px-3 py-6 text-center text-xs text-muted-foreground">
            No content views in this window.
          </p>
        ) : (
          <ul className="space-y-3">
            {topAssets.map((a) => (
              <li key={a.asset_id}>
                <div className="mb-1 flex items-baseline justify-between gap-2">
                  <span className="truncate text-sm font-medium">
                    {a.title}
                  </span>
                  <span className="inline-flex items-center gap-1 text-[11px] tabular-nums text-muted-foreground">
                    <Eye className="h-3 w-3" />
                    {a.views}
                  </span>
                </div>
                <div className="h-1.5 overflow-hidden rounded-full bg-muted">
                  <div
                    className="h-full rounded-full bg-accent"
                    style={{ width: `${(a.views / max) * 100}%` }}
                  />
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>
    </section>
  );
}
